import React from "react";

export default class Checkbox extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isChecked: props.checked != undefined ? props.checked : false
      };
    }
    toggleChange = () => {
      this.setState({
        isChecked: !this.state.isChecked,
      });
      this.props.onElementCheck(this.props.elementId);
    }
    render() {
      return (
          <input type="checkbox"
            defaultChecked={this.state.isChecked}
            onChange={this.toggleChange}
          />
      );
    }
  
}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}